/**
 * Geometry for the avatar-corner placement of the availability dot
 * (SidebarAvatar toggle, Dashboard Member card). Shared so the two avatar
 * surfaces cannot drift in size/position the way they previously drifted
 * in color (RET-1350).
 */
export const AVATAR_CORNER_DOT_CLASSNAME =
  'absolute bottom-0 right-0 w-3 h-3 border-2 border-base-100';
